import Vue from 'vue'
import apis from '@/api'

const loadUserData = (config, formData, globalData, formConfigList, page, pageSize, keyWord) => {
  return new Promise((resolve, reject) => {
    const request = {
      ...apis.QUERY_ALL_USERS,
      params: {
        page,
        pageSize,
        keyWord
      }
    }
    Vue.prototype
      .$request(request)
      .asyncThen(
        (resp) => {
          if (resp.code === 'ok') {
            resolve({
              data: resp.data,
              total: resp.total
            })
          }
        },
        (err) => {
          reject(err)
        }
      )
      .asyncErrorCatch((err) => {
        reject(err)
      })
  })
}

const loadDepartmentData = (config, formData, globalData, formConfigList, deptId) => {
  return new Promise((resolve, reject) => {
    const request = {
      ...apis.QUERY_DEPARTMENT_INFO,
      params: {
        deptId: deptId || ''
      }
    }
    Vue.prototype
      .$request(request)
      .asyncThen(
        (resp) => {
          if (resp.code === 'ok') {
            resolve({
              data: resp.data,
              total: resp.total
            })
          }
        },
        (err) => {
          reject(err)
        }
      )
      .asyncErrorCatch((err) => {
        reject(err)
      })
  })
}

const loadDeptUserData = (config, formData, globalData, formConfigList, page, pageSize, deptId) => {
  return new Promise((resolve, reject) => {
    const request = {
      ...apis.QUERY_DEPARTMENT_USERS,
      params: {
        deptId,
        page,
        pageSize
      }
    }
    Vue.prototype
      .$request(request)
      .asyncThen(
        (resp) => {
          if (resp.code === 'ok') {
            resolve({
              data: resp.data,
              total: resp.total
            })
          }
        },
        (err) => {
          reject(err)
        }
      )
      .asyncErrorCatch((err) => {
        reject(err)
      })
  })
}

const loadRoleData = (config, formData, globalData, formConfigList, page, pageSize, roleId) => {
  return new Promise((resolve, reject) => {
    const request = {
      ...apis.QUERY_ROLE_INFO,
      params: {
        appId: globalData.appId
      }
    }
    Vue.prototype
      .$request(request)
      .asyncThen(
        (resp) => {
          if (resp.code === 'ok') {
            resolve({
              data: resp.data,
              total: resp.total
            })
          }
        },
        (err) => {
          reject(err)
        }
      )
      .asyncErrorCatch((err) => {
        reject(err)
      })
  })
}

const loadRoleUserData = (config, formData, globalData, formConfigList, page, pageSize, roleId) => {
  return new Promise((resolve, reject) => {
    const request = {
      ...apis.QUERY_ROLE_USERS,
      params: {
        page,
        pageSize,
        roleId
      }
    }
    Vue.prototype
      .$request(request)
      .asyncThen(
        (resp) => {
          if (resp.code === 'ok') {
            resolve({
              data: resp.data,
              total: resp.total
            })
          }
        },
        (err) => {
          reject(err)
        }
      )
      .asyncErrorCatch((err) => {
        reject(err)
      })
  })
}

const loadUserDataFilter = (param, formId, uuid, formData) => {
  return new Promise((resolve, reject) => {
    const request = {
      ...apis.QUERY_ALL_USERS_FILTER,
      params: {
        formId,
        componentId: uuid,
        param,
        formData
      }
    }
    Vue.prototype
      .$request(request)
      .asyncThen(
        (resp) => {
          if (resp.code === 'ok') {
            resolve({
              data: resp.data,
              total: resp.total
            })
          }
        },
        (err) => {
          reject(err)
        }
      )
      .asyncErrorCatch((err) => {
        reject(err)
      })
  })
}

const FormPeopleSelectConfig = {
  // 类型
  componentType: 'FORM_PEOPLE_SELECT',
  // 部件显示样式
  widgetConfig: {
    icon: 'x-lib-personal-icon',
    text: '人员选择',
    optionTitle: true,
    description: '用于选择组织中的人员，最多选择50个'
  },
  componentConfig: {
    uuid: `32bit uuid`,
    width: 6, // 3, 6, 9, 12
    height: 1,
    render: {
      edit: 'FormPeopleSelect',
      read: 'FormPeopleSelect'
    },
    label: '人员选择',
    placeholder: '请选择人员',
    inTable: true,
    customDefaultKey: 'userSelectDefaultValue',
    methods: {
      lcLoadUserData: loadUserData,
      lcLoadDepartmentData: loadDepartmentData,
      lcLoadDeptUserData: loadDeptUserData,
      lcLoadRoleData: loadRoleData,
      lcLoadRoleUserData: loadRoleUserData,
      lcLoadUserDataFilter: loadUserDataFilter,
      lcConvertDefaultValue: (config) => {
        if (config.defaultValue === 'Now') {
          const store = require('../../../store/index')
          const storeState = store.default

          const currentUser = storeState.state.authModule.userInfo
          return currentUser ? [{
            id: currentUser.id,
            username: currentUser.username,
            headPortrait: currentUser.avatarUrl,
            phone: currentUser.phone
          }] : []
        } else if (config.defaultValue === 'SpecifyThePeople') {
          return config.userSelectDefaultValue
        } else {
          return []
        }
      }
    }

  },
  editorConfig: [
    'INFO',
    'LABEL',
    'PLACEHOLDER',
    'CHOOSETYPE',
    'PEOPLE_SELECT_DATA_SOURCE',
    'PEOPLE_SELECT_DATA_FILTER',
    'PEOPLE_SELECT_DEFAULT_VALUE',
    'WIDTH',
    'HIDDEN',
    'READONLY',
    'REQUIRED',
    'EDITONNEW',
    'UNIQUE'
  ],
  excludeEditorConfigInTable: ['WIDTH']
}

export default FormPeopleSelectConfig
